import Phones from '../../assets/images/phones.webp';
import { useTranslation } from 'react-i18next';
import { Box, Flex, Heading, Img, Text, List, ListItem, Button, Image } from '@chakra-ui/react';

export default function Download() {
  const { t } = useTranslation();
  return (
    <Box
      bgGradient="linear(45deg, #eedcd1 0%, #FFFFFF 50%, #c9dedd 100%)"
      position="relative"
      mx="auto"
      maxW="7xl"
      my={10}
      mt={20}
      borderRadius="3xl"
      boxShadow="lg"
      overflow="visible"
      px={8}
      className='flex gap-2 justify-center md:justify-end items-end'
    >
      {/* phones images*/}
      <Img
        src={Phones}
        alt={t('download.alt', 'Download')}
        position="absolute"
        left="3rem"
        display={{ base: 'none', md: 'block' }}
        userSelect="none"
        pointerEvents="none"
        className='md:h-[400px] lg:h-[600px] lg:top-[-5rem] z-10'
      />

      {/* circle */}
      <Box className='md:w-1/2 hidden lg:block relative overflow-hidden max-h-[330px]'>
        <div className='h-[400px] rounded-full bg-primary aspect-square ml-10'>
        </div>
      </Box>

      {/* download texts and buttons*/}
      <Flex
        direction="column"
        zIndex={1}
        textAlign="righ"
        alignItems="flex-start"
        color="#232323"
        gap={2}
        my={12}
        className='md:w-1/2'
      >
        <Heading className="text-primary font-brave-hunter" fontFamily='"Brave Hunter", sans-serif' fontWeight='medium'>{t('download.heading')}</Heading>
        <Text fontSize="lg" className="text-[#232323] font-semibold max-w-md">{t('download.description')}</Text>
        <List spacing={1} textAlign="left" className='max-w-md font-semibold'>
          <ListItem>
            <Flex align="center">
              <Box as="span" position="relative" display="inline-flex" alignItems="center" justifyContent="center" w="10px" h="10px" mr={2} flexShrink={0}>
                <Box as="span" position="absolute" w="full" h="full" borderRadius="full" bg="orange.400" className="animate-ping" opacity={0.6} />
                <Box as="span" position="relative" w="full" h="full" borderRadius="full" bg="orange.500" />
              </Box>
              <Text className='text-primary'>{t('download.benefit.fast')}</Text>
            </Flex>
          </ListItem>
          <ListItem>
            <Flex align="center">
              <Box as="span" position="relative" display="inline-flex" alignItems="center" justifyContent="center" w="10px" h="10px" mr={2} flexShrink={0}>
                <Box as="span" position="absolute" w="full" h="full" borderRadius="full" bg="orange.400" className="animate-ping" opacity={0.6} />
                <Box as="span" position="relative" w="full" h="full" borderRadius="full" bg="orange.500" />
              </Box>
              <Text className='text-primary'>{t('download.benefit.payments')}</Text>
            </Flex>
          </ListItem>
          <ListItem>
            <Flex align="center">
              <Box as="span" position="relative" display="inline-flex" alignItems="center" justifyContent="center" w="10px" h="10px" mr={2} flexShrink={0}>
                <Box as="span" position="absolute" w="full" h="full" borderRadius="full" bg="orange.400" className="animate-ping" opacity={0.6} />
                <Box as="span" position="relative" w="full" h="full" borderRadius="full" bg="orange.500" />
              </Box>
              <Text className='text-primary'>{t('download.benefit.promotions')}</Text>
            </Flex>
          </ListItem>
        </List>
        <Text fontSize="lg" className="text-[#232323] font-semibold max-w-md">{t('download.cta')}</Text>
        <Flex direction="row" textAlign="left" justifyContent="flex-start" className='mt-3' gap={2}>
          {/* Buttons become compact icon-only on mobile: hide text and reduce min width/padding */}
          <Button
            as="a"
            href="https://play.google.com/store/apps/details?id=com.danngos.recargas"
            target="_blank"
            rel="noopener noreferrer"
            _hover={{ shadow: 'lg' }}
            px={{ base: 0 }}
            height={{ md: 'fit-content' }}
            variant='ghost'
          >
            <Flex gap={2} alignItems="center">
              <Image src="/google_play.svg" alt="Android" className='h-10' />
            </Flex>
          </Button>
          <Button
            _hover={{ shadow: 'lg' }}
            px={{ base: 0 }}
            height={{ md: 'fit-content' }}
            variant='ghost'
          >
            <Flex gap={2} alignItems="center">
              <Image src="/app_store.svg" alt="iOS" className='h-10' />
            </Flex>
          </Button>
        </Flex>
      </Flex>
    </Box>
  );
}
